/**
 * Centralized answer configuration for quiz and true/false question types.
 * Used by QuizCreator, QuestionDisplay, AnswerButtons, QuestionResults.
 *
 * Brukar Mikkelparken brand-fargar i staden for Kahoot-stil raud/blå/gul/grøn.
 * Magenta er reservert for primær-CTA og blir ikkje brukt på svar-knappar.
 *   A: mørkgrøn  B: rust  C: lime (mørkgrøn tekst)  D: teal
 */

export const ANSWER_CONFIG_QUIZ = [
  { color: 'bg-mp-darkgreen', textColor: 'text-white',        bgColor: 'bg-mp-darkgreen', focusBorder: 'focus:border-mp-darkgreen', icon: 'change_history', lucideName: 'circle',   placeholder: 'Legg til svar 1' },
  { color: 'bg-mp-fox-rust',  textColor: 'text-white',        bgColor: 'bg-mp-fox-rust',  focusBorder: 'focus:border-mp-fox-rust',  icon: 'crop_square',    lucideName: 'square',   placeholder: 'Legg til svar 2' },
  { color: 'bg-mp-lime',      textColor: 'text-mp-darkgreen', bgColor: 'bg-mp-lime',      focusBorder: 'focus:border-mp-lime',      icon: 'circle',         lucideName: 'triangle', placeholder: 'Legg til svar 3' },
  { color: 'bg-mp-teal',      textColor: 'text-white',        bgColor: 'bg-mp-teal',      focusBorder: 'focus:border-mp-teal',      icon: 'rectangle',      lucideName: 'diamond',  placeholder: 'Legg til svar 4' },
];

export const ANSWER_CONFIG_TRUEFALSE = [
  { color: 'bg-mp-darkgreen', textColor: 'text-white', bgColor: 'bg-mp-darkgreen', focusBorder: 'focus:border-mp-darkgreen', icon: 'check_circle', lucideName: 'check', placeholder: 'Sant' },
  { color: 'bg-mp-fox-rust',  textColor: 'text-white', bgColor: 'bg-mp-fox-rust',  focusBorder: 'focus:border-mp-fox-rust',  icon: 'cancel',       lucideName: 'x',     placeholder: 'Usant' },
];

/**
 * Get answer config array based on question type
 * @param {string} questionType - 'quiz' or 'truefalse'
 * @returns {Array} Answer config objects
 */
export function getAnswerConfig(questionType) {
  return questionType === 'truefalse' ? ANSWER_CONFIG_TRUEFALSE : ANSWER_CONFIG_QUIZ;
}

/**
 * Get expected answer count based on question type
 * @param {string} questionType - 'quiz' or 'truefalse'
 * @returns {number} Expected answer count (2 or 4)
 */
export function getAnswerCount(questionType) {
  return questionType === 'truefalse' ? 2 : 4;
}
